import React, { useEffect, useState, useContext } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useFirestore } from "../firebase/FirestoreContext";
import { collection, getDocs, query, where } from "firebase/firestore";
import { EnvContext } from "../context/EnvContext";
import config from "../config";

import { useNavigate } from "react-router-dom";
import cdn from "../utils/cdn";

const Knowledge = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0); // Track active slide
  const [knowledgeData, setKnowledgeData] = useState([]);
  const db = useFirestore();
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  useEffect(() => {
    const fetchKnowledge = async () => {
      if (!db) {
        console.error("Firestore instance is not initialized.");
        return;
      }
      try {
        const knowledgeCollection = collection(db, `${collectionPath}Help/Knowledge/DataBase`);
        const q = query(knowledgeCollection, where("modalVisible", "==", true));
        const knowledgeSnapshot = await getDocs(q);
        const knowledgeList = knowledgeSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setKnowledgeData(knowledgeList);
      } catch (error) {
        console.error("Error fetching knowledge:", error);
      }
    };

    fetchKnowledge();
  }, [db, collectionPath]);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex), // Update active slide index
    customPaging: (i) => (
      <div
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: i === currentSlide ? "#333" : "#bbb", // Highlight active dot
          marginTop: "5px",
          transition: "background-color 0.3s ease",
        }}
      ></div>
    ),
    appendDots: (dots) => (
      <div style={styles.dotsContainer}>
        <ul style={styles.dotsList}>{dots}</ul>
      </div>
    ),
  };

  return (
    <div css={styles.wrapper}>
      <div style={styles.container}>
        {/* Fixed Top Section */}
        <div style={{ background: "#808a79" }}>
          <div style={styles.fixedHeader} onClick={() => navigate("/knowledge")}>
            <div style={{ ...styles.imageWrapper, backgroundImage: `url(${cdn.image('/images/knowledge/knowledge.png', { w: 1000 })})` }} />
          </div>
        </div>

        {/* Scrollable Slider */}
        <div style={styles.sliderContainer}>
          <Slider {...settings}>
            {knowledgeData.map((item, index) => (
              <div key={index} style={styles.slide}>
                <h3 style={styles.title}>{item.articleTitle}</h3>
                <p style={styles.description}>{item.shortDescription}</p>
                <a href={"knowledge/" + item.customURL} style={styles.readMore}>
                  Read More
                </a>
              </div>
            ))}
          </Slider>
        </div>

        {/* Fixed Bottom Section (Holds Dots) */}
        <div style={styles.fixedBottom}>{/* Dots are now properly placed inside this section */}</div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  container: {
    borderRadius: "22px",
    overflow: "hidden",
    backgroundColor: "#fbffdb",
    position: "relative",
    margin: "20px 10px",
  },
  fixedHeader: {
    position: "relative",
    width: "100%",
    maxWidth: "800px", // Add a maximum width
    margin: "0 auto", // Center the header horizontally
    overflow: "hidden",
    aspectRatio: "16/8",
    maxHeight: "350px",
    cursor: "pointer",
  },
  imageWrapper: {
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.3)",
  },
  heading: {
    position: "relative",
    zIndex: 2,
    color: "white",
    fontSize: "1.8rem",
    fontWeight: "bold",
    textTransform: "uppercase",
    textAlign: "center",
    lineHeight: "1.2",
  },
  sliderContainer: {
    padding: "20px",
    textAlign: "center",
    minHeight: "150px",
  },
  slide: {
    padding: "10px",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
  },
  description: {
    fontSize: "18px",
    fontWeight: "500",
    color: "#555",
    margin: "8px 0",
  },
  readMore: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "black",
    textDecoration: "underline",
    cursor: "pointer",
  },
  fixedBottom: {},
  dotsContainer: {
    position: "relative",
    width: "auto",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "center",
  },
  dotsList: {
    display: "flex",
    background: "#edefda",
    borderRadius: "50px",
    padding: "5px",
    width: "auto",
    marginBottom: "30px",
    paddingLeft: "15px",
  },
};

export default Knowledge;
